import React from 'react';
import PropTypes from 'prop-types';
import { loadStrings } from './';

class StringProvider extends React.Component {
  constructor(props) {
    super(props);
    loadStrings(props.strings);
  }

  render() {
    return this.props.children;
  }
}
StringProvider.propTypes = {
  strings: PropTypes.oneOfType([PropTypes.any]),
  children: PropTypes.element
};
StringProvider.defaultProps = {
  children: null,
  strings: {}
};

export default StringProvider;
